export class Controller {

    /** @ngInject */
    constructor($state, Alert, DestructiveOperationModal) {
        this.$state = $state;
        this.Alert = Alert;
        this.DestructiveOperationModal = DestructiveOperationModal;
    }

    $onInit() {
        this.keepAccountsAndGroups = "keepAccountsAndGroups" // possible values are "keepAccountsAndGroups" | "keepAccountsOnly" | "keepGroupsOnly" | "deleteAccountsAndGroups";
    }

    remove() {
        // DirectoriesResource.deleteDirectory()
        let keepAccounts = ["keepAccountsAndGroups", "keepAccountsOnly"].indexOf(this.keepAccountsAndGroups) >= 0;
        let keepGroups = ["keepAccountsAndGroups", "keepGroupsOnly"].indexOf(this.keepAccountsAndGroups) >= 0;
        const url = `app/rest/v2/company/${this.companyId}/directories/${this.directory.id}?keepAccounts=${keepAccounts}&keepGroups=${keepGroups}&type=${this.directory.type}`;
        this.DestructiveOperationModal({
            titleKey: 'company.directory-integration.manage.main.remove.$title',
            textKey: 'company.directory-integration.manage.main.remove.are-you-sure',
            http: {method: 'DELETE', url},
        }).then(() => {
            this.Alert('success', 'company.directory-integration.manage.main.remove.removed', {directoryTypeName: this.directory.typeName});
            this.$state.go('company.directory-integration', {}, {reload: true});
        });
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/main/remove/remove-directory.controller.js